module.exports = __webpack_public_path__ + "img/xc_map.f93fc3cb.jpg";